export function expand() {
    var secondaryDescription = document.querySelector('.site-event-details__secondary-description');
    var readMoreButton = document.querySelector('.site-event-details__read-more');

    if (secondaryDescription && readMoreButton) {
        readMoreButton.addEventListener('click', function () {
            var isExpanded = secondaryDescription.classList.toggle('site-event-details__secondary-description--active');
            if (isExpanded) {
                // Expand the content and set button to "Read Less"
                secondaryDescription.style.maxHeight = secondaryDescription.scrollHeight + 1000 + "px";
                readMoreButton.innerHTML = 'Read Less';
                readMoreButton.style.marginTop = '10px';
            } else {
                // Collapse the content and set button back to "Read More"
                secondaryDescription.style.maxHeight = '250px';
                readMoreButton.innerHTML = 'Read More';
                
            }
            secondaryDescription.style.transition = 'max-height 0.5s ease-in-out';
        });
    }
}
